import { render, staticRenderFns } from "./PaginatedTable.vue?vue&type=template&id=1770ce19&scoped=true"
import script from "./PaginatedTable.vue?vue&type=script&lang=js"
export * from "./PaginatedTable.vue?vue&type=script&lang=js"
import style0 from "./PaginatedTable.vue?vue&type=style&index=0&id=1770ce19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1770ce19",
  null
  
)

export default component.exports